import React from 'react';
import { Box, Typography } from '@mui/material';
import { MdOutlineInventory } from 'react-icons/md';

const Inventorymanagement = () => {
    return (
        <Box sx={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', minHeight: '60vh', gap: 2, color: '#9ca3af'
        }}>
            <MdOutlineInventory size={56} />
            <Typography variant="h6" sx={{ fontFamily: 'Mulish, sans-serif', fontWeight: 700, color: '#6b7280' }}>
                Inventory Management
            </Typography>
            <Typography sx={{ fontFamily: 'Mulish, sans-serif', fontSize: '0.9rem', color: '#9ca3af' }}>
                This module is currently under development.
            </Typography>
        </Box>
    );
};

export default Inventorymanagement;

// import {
//   Box,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
//   IconButton,
//   Button,
//   TextField,
//   Grid,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   MenuItem,
//   DialogContentText,
//   Pagination,
//   Autocomplete
// } from '@mui/material';
// import { postData, getData, deleteData, putData } from '../Webservice/Webservice';
// import { MdDeleteForever } from 'react-icons/md';
// import { FaPlus, FaArrowLeft, FaEye } from 'react-icons/fa';
// import { MdOutlineInventory } from "react-icons/md";

// const Inventorymanagement = () => {
//     const [openAddStock, setOpenAddStock] = useState(false);
//     const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//     const [itemToDelete, setItemToDelete] = useState(null);
//     const [isViewMode, setIsViewMode] = useState(false);
//     const [isEditMode, setIsEditMode] = useState(false);
//     const [selectedItem, setSelectedItem] = useState(null);
//     const [formData, setFormData] = useState({
//         product_id: '',
//         batch_no: '',
//         warehouseId: '',
//         quantity: '',
//         maximumRetailPrice: '',
//         sellingPrice: '',
//         purchasePrice: '',
//         manufactureDate: '',
//         expireDate: ''
//     });
//     const [warehouseList, setWarehouseList] = useState([]);
//     const [productList, setProductList] = useState([]);
//     const PAGE_SIZE = 10;
//     const [meta, setMeta] = useState({ page: 1, totalPages: 1, total: 0 });
//     const [inventory, setInventory] = useState([]);
//     const [loading, setLoading] = useState(true);

//     // Pagination handler
//     const handlePageChange = (event, newPage) => {
//         setMeta((prev) => ({ ...prev, page: newPage }));
//     };

//     useEffect(() => {
//         const fetchWarehouses = async () => {
//             try {
//                 const tokenValue = sessionStorage.getItem('token');
//                 const token = tokenValue ? `Bearer ${tokenValue}` : '';
//                 const data = await getData('warehouse/list', null, token, false);
//                 setWarehouseList(data?.warehouse || []);
//             } catch (error) {
//                 setWarehouseList([]);
//             }
//         };

//         const fetchProducts = async () => {
//             try {
//                 const tokenValue = sessionStorage.getItem('token');
//                 const token = tokenValue ? `Bearer ${tokenValue}` : '';
//                 const response = await getData('product/list', null, token);
//                 const productsArray = Array.isArray(response?.products)
//                     ? response.products
//                     : Array.isArray(response)
//                         ? response
//                         : (response.data || []);
//                 setProductList(productsArray);
//             } catch (error) {
//                 setProductList([]);
//             }
//         };

//         const fetchInventory = async (page = 1) => {
//             setLoading(true);
//             try {
//                 const tokenValue = sessionStorage.getItem('token');
//                 const token = tokenValue ? `Bearer ${tokenValue}` : '';
//                 const params = {
//                     page,
//                     limit: PAGE_SIZE
//                 };
//                 const response = await getData('stock/list', params, token);
//                 setInventory(response?.stock || []);
//                 const meta = response?.meta || { page: 1, totalPages: 1, total: 0 };
//                 setMeta({
//                     page: meta.page,
//                     totalPages: meta.totalPages,
//                     total: meta.total
//                 });
//             } catch (error) {
//                 setInventory([]);
//                 setMeta({ page: 1, totalPages: 1, total: 0 });
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchWarehouses();
//         fetchProducts();
//         fetchInventory(meta.page);
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [meta.page]);

//     const handleOpenAddStock = () => {
//         setIsViewMode(false);
//         setIsEditMode(false);
//         setSelectedItem(null);
//         setOpenAddStock(true);
//     };

//     const handleCloseAddStock = () => {
//         setOpenAddStock(false);
//         setIsViewMode(false);
//         setIsEditMode(false);
//         setSelectedItem(null);
//         setFormData({
//             product_id: '',
//             batch_no: '',
//             warehouseId: '',
//             quantity: '',
//             maximumRetailPrice: '',
//             sellingPrice: '',
//             purchasePrice: '',
//             manufactureDate: '',
//             expireDate: ''
//         });
//     };

//     const handleViewItem = (item) => {
//         setIsViewMode(false);
//         setIsEditMode(true);
//         setSelectedItem(item);
//         setFormData({
//             product_id: item.product_id?._id || item.product_id || '',
//             batch_no: item.batch_no || '',
//             warehouseId: item.warehouseId || '',
//             quantity: item.quantity || '',
//             maximumRetailPrice: item.maximumRetailPrice || '',
//             sellingPrice: item.sellingPrice || '',
//             purchasePrice: item.purchasePrice || '',
//             manufactureDate: item.manufactureDate ? item.manufactureDate.slice(0, 10) : '',
//             expireDate: item.expireDate ? item.expireDate.slice(0, 10) : ''
//         });
//         setOpenAddStock(true);
//     };

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             const tokenValue = sessionStorage.getItem('token');
//             const token = tokenValue ? `Bearer ${tokenValue}` : '';

//             if (isEditMode && selectedItem) {
//                 // Update existing stock
//                 await putData(`stock/update/${selectedItem._id}`, formData, token);

//                 // Update the inventory list
//                 setInventory(inventory.map(item =>
//                     item._id === selectedItem._id
//                         ? { ...item, ...formData }
//                         : item
//                 ));
//             } else {
//                 // Add new stock
//                 await postData('stock/add', formData, token);

//                 const selectedProduct = productList.find(p => p._id === formData.product_id);
//                 const newStockItem = {
//                     ...formData,
//                     product: selectedProduct ? selectedProduct.title : formData.product_id
//                 };

//                 setInventory([...inventory, newStockItem]);
//             }

//             handleCloseAddStock();
//         } catch (error) {
//             // Error toast is handled in postData
//         }
//     };

//     const handleDeleteClick = (item) => {
//         setItemToDelete(item);
//         setDeleteDialogOpen(true);
//     };

//     const handleDeleteConfirm = async () => {
//         if (!itemToDelete) return;

//         try {
//             const tokenValue = sessionStorage.getItem('token');
//             const token = tokenValue ? `Bearer ${tokenValue}` : '';
//             await deleteData(`stock/delete/${itemToDelete._id}`, token);

//             // Remove the item from the inventory list
//             setInventory(inventory.filter(item => item._id !== itemToDelete._id));
//             handleDeleteCancel();
//         } catch (error) {
//             console.error("Error deleting item:", error);
//         }
//     };

//     const handleDeleteCancel = () => {
//         setDeleteDialogOpen(false);
//         setItemToDelete(null);
//     };

//     return (
//         <Box p={3}>
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
//                 <Typography variant="h3" mb={2}  sx={{fontFamily: 'Mulish, sans-serif'}}>Inventory Management</Typography>
//                 <Button
//                     variant="contained"
//                     startIcon={<MdOutlineInventory />}
//                     onClick={handleOpenAddStock}
//                     sx={{
//                         fontFamily: 'Mulish, sans-serif',
//                         color: "black",
//                         border:'1px solid black',
//                         background: 'rgb(255 209 2)',
//                         '&:hover': {
//                             background: 'rgb(255 209 2)'
//                         }
//                     }}
//                 >
//                     Add Stock
//                 </Button>
//             </Box>

//             <TableContainer component={Paper}  sx={{
//                                         borderRadius: '8px',
//                                         boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
//                                         border:'1px solid #d3d3d3de',
//                                     }}>
//                 <Table>
//                     <TableHead>
//                         <TableRow sx={{ backgroundColor: 'rgb(255 209 2)', }}>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif', fontSize: 16, }}>Product</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif', fontSize: 16 ,  }}>Batch No</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif', fontSize: 16,   }}>Warehouse</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif' , fontSize: 16 , }}>Quantity</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif', fontSize: 16 ,  }}>MRP</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif' , fontSize: 16,  }}>Selling Price</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif', fontSize: 16 , }}>Purchase Price</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif', fontSize: 16 , }}>Manufacture Date</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif', fontSize: 16 ,  }}>Expire Date</TableCell>
//                             <TableCell sx={{ fontWeight: 'bold',fontFamily: 'Mulish, sans-serif', fontSize: 16 , }}>Delete</TableCell>
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {inventory.map((row, idx) => {
//                             const warehouseObj = warehouseList.find(w => w._id === row.warehouseId);
//                             const warehouseName = warehouseObj ? warehouseObj.name : row.warehouseId;

//                             return (
//                                 <TableRow key={row._id || idx} hover>
//                                     <TableCell
//                                         style={{
//                                             cursor: 'pointer',
//                                             fontFamily:'Mulish, sans-serif',
//                                             '&:hover': {
//                                                 backgroundColor: 'rgba(0,0,0,0.04)'
//                                             }
//                                         }}
//                                         onClick={() => handleViewItem(row)}
//                                         title="Click to view details"
//                                     >
//                                         {row.product_id?.title || ''}
//                                     </TableCell>
//                                     <TableCell
//                                         style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}
//                                         onClick={() => handleViewItem(row)}
//                                     >
//                                         {row.batch_no}
//                                     </TableCell>
//                                     <TableCell
//                                         style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}
//                                         onClick={() => handleViewItem(row)}
//                                     >
//                                         {warehouseName}
//                                     </TableCell>
//                                     <TableCell
//                                         style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}
//                                         onClick={() => handleViewItem(row)}
//                                     >
//                                         {row.quantity}
//                                     </TableCell>
//                                     <TableCell
//                                         style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}
//                                         onClick={() => handleViewItem(row)}
//                                     >
//                                         {row.maximumRetailPrice}
//                                     </TableCell>
//                                     <TableCell
//                                         style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}
//                                         onClick={() => handleViewItem(row)}
//                                     >
//                                         {row.sellingPrice}
//                                     </TableCell>
//                                     <TableCell
//                                         style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}
//                                         onClick={() => handleViewItem(row)}
//                                     >
//                                         {row.purchasePrice}
//                                     </TableCell>
//                                     <TableCell
//                                         style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}
//                                         onClick={() => handleViewItem(row)}
//                                     >
//                                         {row.manufactureDate ? row.manufactureDate.slice(0,10) : ''}
//                                     </TableCell>
//                                     <TableCell
//                                         style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}
//                                         onClick={() => handleViewItem(row)}
//                                     >
//                                         {row.expireDate ? row.expireDate.slice(0,10) : ''}
//                                     </TableCell>
//                                     <TableCell style={{ cursor: 'pointer', fontFamily:'Mulish, sans-serif' }}>
//                                         <IconButton onClick={() => handleDeleteClick(row)}>
//                                             <MdDeleteForever style={{ color: 'red', fontSize: '1.4rem' }} />
//                                         </IconButton>
//                                     </TableCell>
//                                 </TableRow>
//                             );
//                         })}
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//             {/* Pagination Component (centered, like Categories/ActivityLog) */}
//             <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, '& .MuiPagination-ul': { flexWrap: 'nowrap' } }}>
//                 <Pagination
//                     count={meta.totalPages}
//                     page={meta.page}
//                     onChange={handlePageChange}
//                     color="primary"
//                     shape="rounded"
//                     showFirstButton
//                     showLastButton
//                 />
//             </Box>
//             {meta.total > 0 && (
//                 <Typography variant="caption" color="textSecondary" sx={{ mt: 1, display: 'block', textAlign: 'center' }}>
//                     Showing {(meta.page - 1) * PAGE_SIZE + 1} to {Math.min(meta.page * PAGE_SIZE, meta.total)} of {meta.total} entries
//                 </Typography>
//             )}

//             {/* Add Stock Dialog */}
//             <Dialog open={openAddStock} onClose={handleCloseAddStock} maxWidth="md" fullWidth>
//                 <DialogTitle>
//                     <Box display="flex" alignItems="center">
//                         <IconButton onClick={handleCloseAddStock} sx={{ mr: 1 }}>
//                             <FaArrowLeft />
//                         </IconButton>
//                         <Box display="flex" alignItems="center" gap={1}>
//                             <Typography variant="h6" sx={{fontFamily:'Mulish, sans-serif',}}>
//                                 {isEditMode ? 'Update Stock Details' : 'Add New Stock'}
//                             </Typography>
//                         </Box>
//                     </Box>
//                 </DialogTitle>
//                 <DialogContent>
//                     <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2, p: 1 }}>
//                         <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//     <Autocomplete
//     options={productList}
//     getOptionLabel={(option) => option.title || ""}
//     value={productList.find(p => p._id === formData.product_id) || null}
//     onChange={(event, newValue) => {
//     handleInputChange({
//         target: {
//         name: "product_id",
//         value: newValue ? newValue._id : ""
//         }
//       });
//     }}
//     renderInput={(params) => (
//       <TextField
//         {...params}
//         label="Product"
//         required
//         fullWidth
//         placeholder="Search product..."
//       />
//     )}
//     renderOption={(props, option) => (
//       <MenuItem
//         {...props}
//         key={option._id}
//         style={{ height: 48 }} // Fixed menu item height
//       >
//         {option.title}
//       </MenuItem>
//     )}
//     isOptionEqualToValue={(option, value) => option._id === value._id}
//     ListboxProps={{
//       style: {
//         maxHeight: 144, // 3 items * 48px each
//         overflow: 'auto',
//       }
//     }}
//     PaperComponent={({ children }) => (
//       <Paper style={{
//         marginTop: 8,
//         boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
//       }}>
//         {children}
//       </Paper>
//     )}
//     noOptionsText="No products found" // Shown when no options match search
//   />
// </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="Batch No"
//                                     name="batch_no"
//                                     value={formData.batch_no}
//                                     onChange={handleInputChange}
//                                     required
//                                     disabled={false}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//     <Autocomplete
//         options={warehouseList}
//         getOptionLabel={(option) => option.name || ""}
//         value={warehouseList.find(w => w._id === formData.warehouseId) || null}
//         onChange={(event, newValue) => {
//             handleInputChange({
//                 target: {
//                     name: "warehouseId",
//                     value: newValue ? newValue._id : ""
//                 }
//             });
//         }}
//         renderInput={(params) => (
//             <TextField
//                 {...params}
//                 label="Warehouse"
//                 required
//                 fullWidth
//                 placeholder="Search warehouse..."
//             />
//         )}
//         renderOption={(props, option) => (
//             <MenuItem
//                 {...props}
//                 key={option._id || option.id}
//                 style={{
//                     height: 48, // Standard MenuItem height
//                 }}
//             >
//                 {option.name}
//             </MenuItem>
//         )}
//         isOptionEqualToValue={(option, value) =>
//             option._id === value._id || option.id === value.id
//         }
//         ListboxProps={{
//             style: {
//                 maxHeight: 144, // 3 items * 48px each
//                 overflow: 'auto',
//             }
//         }}
//         PaperComponent={({ children }) => (
//             <Paper style={{
//                 marginTop: 8, // Add some spacing from the input
//                 boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
//             }}>
//                 {children}
//             </Paper>
//         )}
//     />
// </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="Quantity"
//                                     name="quantity"
//                                     type="number"
//                                     value={formData.quantity}
//                                     onChange={handleInputChange}
//                                     required
//                                     disabled={false}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                                 <TextField
//                                     fullWidth
//                                     label="Maximum Retail Price"
//                                     name="maximumRetailPrice"
//                                     type="number"
//                                     value={formData.maximumRetailPrice}
//                                     onChange={handleInputChange}
//                                     required
//                                     disabled={false}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                                 <TextField
//                                     fullWidth
//                                     label="Selling Price"
//                                     name="sellingPrice"
//                                     type="number"
//                                     value={formData.sellingPrice}
//                                     onChange={handleInputChange}
//                                     required
//                                     disabled={false}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={4}>
//                                 <TextField
//                                     fullWidth
//                                     label="Purchase Price"
//                                     name="purchasePrice"
//                                     type="number"
//                                     value={formData.purchasePrice}
//                                     onChange={handleInputChange}
//                                     required
//                                     disabled={false}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="Manufacture Date"
//                                     name="manufactureDate"
//                                     type="date"
//                                     value={formData.manufactureDate}
//                                     onChange={handleInputChange}
//                                     required
//                                     disabled={false}
//                                     InputLabelProps={{
//                                         shrink: true,
//                                     }}
//                                 />
//                             </Grid>
//                             <Grid item xs={12} sm={6}>
//                                 <TextField
//                                     fullWidth
//                                     label="Expire Date"
//                                     name="expireDate"
//                                     type="date"
//                                     value={formData.expireDate}
//                                     onChange={handleInputChange}
//                                     required
//                                     disabled={false}
//                                     InputLabelProps={{
//                                         shrink: true,
//                                     }}
//                                 />
//                             </Grid>
//                         </Grid>
//                     </Box>
//                 </DialogContent>
//                 <DialogActions
//                     sx={{ paddingRight: "33px", paddingBottom: '24px' }}>
//                     <Button onClick={handleCloseAddStock} sx={{ color: 'red' }}>Close</Button>
//                     <Button
//                         onClick={handleSubmit}
//                         variant="contained"
//                         sx={{
//                             color: "black",
//                             background: 'rgb(255 209 2)',
//                             '&:hover': {
//                                 background: 'rgb(255 209 2)'
//                             }
//                         }}
//                     >
//                         {isEditMode ? 'Update Stock' : 'Add Stock'}
//                     </Button>
//                 </DialogActions>
//             </Dialog>

//             {/* Delete Confirmation Dialog */}
//             <Dialog
//                 open={deleteDialogOpen}
//                 onClose={handleDeleteCancel}
//                 PaperProps={{
//                     style: {
//                         borderRadius: '10px',
//                         padding: '20px',
//                         minWidth: '400px'
//                     }
//                 }}
//             >
//                 <DialogTitle sx={{ fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>
//                     <img style={{ width: '80px' }} src='./img/del1.png' alt='delete' />
//                 </DialogTitle>
//                 <DialogContent>
//                     <DialogContentText sx={{ textAlign: 'center', fontSize: '16px', mb: 1 }}>
//                         Are you sure you want to delete this inventory item?
//                         {itemToDelete && (
//                             <>
//                                 <br />
//                                 <b>Product: {itemToDelete.product_id?.title || 'N/A'}</b>
//                                 <br />
//                                 <b>Batch No: {itemToDelete.batch_no || 'N/A'}</b>
//                             </>
//                         )}
//                     </DialogContentText>
//                     <Box sx={{
//                         textAlign: 'center',
//                         backgroundColor: '#fff3cd',
//                         padding: '12px',
//                         borderRadius: '4px',
//                         borderLeft: '4px solid #ffc107',
//                         marginBottom: '2px'
//                     }}>
//                         <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#856404', marginBottom: '3px' }}>
//                             Warning
//                         </Typography>
//                         <Typography variant="body2" sx={{ color: '#856404' }}>
//                             By deleting, you won't be able to access it again.
//                         </Typography>
//                     </Box>
//                 </DialogContent>
//                 <DialogActions sx={{ justifyContent: 'center', gap: '20px', padding: '20px' }}>
//                     <Button
//                         onClick={handleDeleteCancel}
//                         variant="outlined"
//                         sx={{
//                             minWidth: '120px',
//                             borderColor: 'gray',
//                             color: 'gray',
//                             '&:hover': {
//                                 borderColor: 'darkgray',
//                                 backgroundColor: 'rgba(0,0,0,0.05)'
//                             }
//                         }}
//                     >
//                         No, Cancel
//                     </Button>
//                     <Button
//                         onClick={handleDeleteConfirm}
//                         variant="contained"
//                         sx={{
//                             minWidth: '120px',
//                             backgroundColor: 'red',
//                             '&:hover': {
//                                 backgroundColor: '#bb2d3b'
//                             }
//                         }}
//                         autoFocus
//                     >
//                         Yes, Delete
//                     </Button>
//                 </DialogActions>
//             </Dialog>
//         </Box>
//     );
// };

// export default Inventorymanagement;
